import React from 'react';
import { Card } from '../ui/card';

const TermsOfService = () => {
  return (
    <div className="max-w-4xl mx-auto py-16 px-4">
      <Card className="p-8 bg-black/40 border-white/10">
        <h1 className="heading-1 mb-8 text-white">Terms of Service</h1>
        <div className="space-y-6 text-gray-300 body-medium">
          
          <section>
            <h2 className="heading-2 mb-4 text-white">1. Acceptance of Terms</h2>
            <p>
              By accessing and using the Godquantum Systems website and services, you agree to be bound by 
              these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">2. Description of Services</h2>
            <p>
              Godquantum Systems provides quantum computing solutions, including but not limited to:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Quantum Operating System (Quantum OS)</li>
              <li>Quantum computing hardware and software solutions</li>
              <li>Consulting and support services</li>
              <li>Educational and informational content</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">3. User Responsibilities</h2>
            <h3 className="heading-3 mb-2 text-emerald-300">You agree to:</h3>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide accurate and complete information</li>
              <li>Use our services in compliance with applicable laws</li>
              <li>Not engage in unauthorized access or malicious activities</li>
              <li>Respect intellectual property rights</li>
              <li>Maintain confidentiality of sensitive information</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">4. Intellectual Property</h2>
            <p>
              All content, technologies, and intellectual property on our website and services are owned by 
              Godquantum Systems or its licensors. You may not copy, distribute, or create derivative works 
              without express written permission.
            </p>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">5. Privacy and Data Protection</h2>
            <p>
              Your privacy is important to us. Please review our Privacy Policy to understand how we 
              collect, use, and protect your information.
            </p>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">6. Disclaimers and Limitations</h2>
            <p>
              Our services are provided "as is" without warranties of any kind. We do not guarantee 
              uninterrupted access or error-free operation. Our liability is limited to the maximum 
              extent permitted by law.
            </p>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">7. Governing Law and Jurisdiction</h2>
            <p>
              These Terms are governed by the laws of India. Any disputes shall be resolved in the 
              courts of New Delhi, India, or the local geography where business is conducted.
            </p>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">8. Contact Information</h2>
            <div className="p-4 bg-white/5 rounded-lg border border-emerald-500/20">
              <p><strong>Email:</strong> contact@godquantum.tech</p>
              <p><strong>Company:</strong> Godquantum Systems Tech Research Labs India Pvt Ltd</p>
              <p className="text-sm text-gray-400 mt-2">Bengaluru, Karnataka, India</p>
            </div>
          </section>

        </div>
      </Card>
    </div>
  );
};

export default TermsOfService;